import React, { SyntheticEvent, useCallback, useEffect, useMemo, useState } from "react";
import {
  Button,
  Grid,
  Icon,
  Input,
  Label,
  Modal,
  Popup,
  TextArea,
  Form,
  Loader,
  Dropdown,
  ButtonProps,
} from "semantic-ui-react";

import config from "config/config";
import htmlParse from "html-react-parser";
import _ from "react-lib/compat/lodashplus";
import moment from "moment";
import { RowInfo } from "react-table-6";

import { Table } from "react-lib/frameworks/Table";

// Interface
import { CARD_DUPLICATE_REASON, CARD_DUPLICATE_CLASSIFICATION_REASON } from "./TPDInterface";

// ui common
import ModPlanning from "../common/ModPlanning";
import SnackMessage from "react-lib/apps/common/SnackMessage";
import ModMedReconcileAlert from "react-lib/apps/common/ModMedReconcileAlert";
import ErrorMessage from "react-lib/apps/common/ErrorMessage";
import ButtonLoadCheck from "react-lib/appcon/common/ButtonLoadCheck";
import ModConfirm from "react-lib/apps/common/cnmi/ModConfirm";
import SubDrugNameFormat from "react-lib/apps/HISV3/common/SubDrugNameFormat";

// ui tpd
import CardDrugContinuePlanUX from "./CardDrugContinuePlanUX";
import CardDrugClaimQA from "./CardDrugClaimQA";
import CardDuplicateDrugOrders from "./CardDuplicateDrugOrders";
import CardDuplicateDrugClassificationOrders from "./CardDuplicateDrugClassificationOrders";
import DrugActionLog from "./DrugActionLog";
import ModCheckADR from "./ModCheckADR";
import ModCheckDI from "./ModCheckDIUX";
import ModSpecialDirection from "./ModSpecialDirection";
import ModSolventSelection from "./ModSolventSelection";
import ModCheckDoctorCertificateUX from "./ModCheckDoctorCertificateUX";
import ModCertificateErrorUX from "./ModCertificateErrorUX";
import SubDrugOrderStatusAlert from "./SubDrugOrderStatusAlert";
import ModDrugLabInteraction from "./ModDrugLabInteraction";
import ModDrugDisease from "./ModDrugDisease";
import ModDrugInteraction from "./ModDrugInteraction";
import ModDrugFact from "./ModDrugFact";
import ModDescriptionUD from "./ModDescriptionUD";
import ModPediatricDose from "./ModPediatricDose";
import DrugSearchBox from "./DrugSearchBox";
import SearchBoxDropdown, { SelectedItemHandler } from "react-lib/appcon/common/SearchBoxDropdown";
import { CalculatorIcon, CustomRadioButton, getPrnOptions, INITIAL_SOLVENT_ADR, INITIAL_SOLVENT_DATA, prepareModSolventSelection } from "./CardEditMedOrder";
import { MOD_SOLVENT_SELECTION_ID } from "./ModSolventSelectionInterface";
import ActionMenuColumn, { CallbackHandler } from "react-lib/apps/HISV3/DPI/ActionMenuColumn";
import ModDrugEditNote from "./ModDrugEditNote";


// Utils
import { getStatusOff } from "../DPI/CardOrderSummary";
import { useIntl } from "react-intl";

export const CARD_DRUG_CONT_ID = "CardDrugContinuePlan";

const SUB_DRUG_CONT_ACTION_ID = "SubDrugContinueActionMenu";
const DRUG_ORDER_TYPE = "Continue";

const BYPASS_DOCTOR_CERT_KEYING = true; // Feature 68144

// ================================================== ActionMenuColumn
// export const ActionMenuColumn = (props: any) => {
//   const [isOpen, setIsOpen] = useState<boolean>(false);
//   const [currentAction, setCurrentAction] = useState<string>("");

//   useEffect(() => {
//     if (props.plan_item?.id && isOpen) {
//       props.setProp("planningData", props.plan_item);
//     }
//   }, [props.plan_item, isOpen]);

//   useEffect(() => {
//     if (
//       currentAction !== "" &&
//       ["ERROR", "SUCCESS"].includes(
//         props.buttonLoadCheck?.[`${SUB_DRUG_CONT_ACTION_ID}_${currentAction}`]
//       )
//     ) {
//       setIsOpen(false);
//       setCurrentAction("");
//     }
//   }, [props.buttonLoadCheck]);

//   const handleActionPlanItem = (event: any, data: any) => {
//     setCurrentAction(data.name);
//     props.onEvent({
//       message: "handleActionPlanItem",
//       params: { action: data.name, card: SUB_DRUG_CONT_ACTION_ID },
//     });
//   };

//   return (
//     <>
//       {
//         <div style={{ display: "flex", justifyContent: "center" }}>
//           <Popup
//             open={isOpen}
//             style={{ padding: "6px 8px" }}
//             content={
//               <>
//                 <ButtonLoadCheck
//                   // function
//                   setProp={props.setProp}
//                   onClick={handleActionPlanItem}
//                   // data
//                   paramKey={`${SUB_DRUG_CONT_ACTION_ID}_RESUME`}
//                   buttonLoadCheck={props.buttonLoadCheck?.[`${SUB_DRUG_CONT_ACTION_ID}_RESUME`]}
//                   // config
//                   color="blue"
//                   name="RESUME"
//                   style={{
//                     display: props.plan_item?.allowed_actions?.includes("RESUME") ? "" : "none",
//                   }}
//                   title="RESUME"
//                 />

//                 <ButtonLoadCheck
//                   // function
//                   setProp={props.setProp}
//                   onClick={handleActionPlanItem}
//                   // data
//                   paramKey={`${SUB_DRUG_CONT_ACTION_ID}_OFF`}
//                   buttonLoadCheck={props.buttonLoadCheck?.[`${SUB_DRUG_CONT_ACTION_ID}_OFF`]}
//                   // config
//                   color="black"
//                   name="OFF"
//                   style={{
//                     display: props.plan_item?.allowed_actions?.includes("OFF") ? "" : "none",
//                   }}
//                   title="OFF"
//                 />

//                 <ButtonLoadCheck
//                   // function
//                   setProp={props.setProp}
//                   onClick={handleActionPlanItem}
//                   // data
//                   paramKey={`${SUB_DRUG_CONT_ACTION_ID}_HOLD`}
//                   buttonLoadCheck={props.buttonLoadCheck?.[`${SUB_DRUG_CONT_ACTION_ID}_HOLD`]}
//                   // config
//                   color="brown"
//                   name="HOLD"
//                   style={{
//                     display: props.plan_item?.allowed_actions?.includes("HOLD") ? "" : "none",
//                   }}
//                   title="HOLD"
//                 />

//                 <ButtonLoadCheck
//                   // function
//                   setProp={props.setProp}
//                   onClick={handleActionPlanItem}
//                   // data
//                   paramKey={`${SUB_DRUG_CONT_ACTION_ID}_RENEW`}
//                   buttonLoadCheck={props.buttonLoadCheck?.[`${SUB_DRUG_CONT_ACTION_ID}_RENEW`]}
//                   // config
//                   color="teal"
//                   name="RENEW"
//                   style={{
//                     display: props.plan_item?.allowed_actions?.includes("RENEW") ? "" : "none",
//                   }}
//                   title="RENEW"
//                 />
//               </>
//             }
//             position="bottom right"
//             onOpen={() => setIsOpen(true)}
//             onClose={() => setIsOpen(false)}
//             on="click"
//             trigger={
//               <Button
//                 icon="list layout"
//                 size="small"
//                 onClick={(e) => e.stopPropagation()}
//                 onDoubleClick={(e: any) => e.stopPropagation()}
//               ></Button>
//             }
//           />
//         </div>
//       }
//     </>
//   );
// };

// ================================================== CardDrugContinuePlan
type CardDrugContinuePlanProps = {
  // sequence
  runSequence: any;
  DrugSelectSequence: any;

  // function
  onEvent: any;
  setProp: any;

  // CommonInterface
  errorMessage?: any;
  successMessage?: any;
  buttonLoadCheck?: any;

  // permission
  drugPermission?: any;

  // options
  duplicateReasonsOptions?: any[];

  // selected data
  selectedPatient?: any;
  selectedEncounter?: any;
  selectedDrug?: any;

  // search drug
  drugSearchLoading?: boolean;
  drugSearchText?: string;
  drugSearchResult?: any[];

  // drug list
  drugContinueFilter?: any;
  drugContinuePlanItems?: any[];

  // planning
  modPlanningConfig?: any;
  planningData?: any;

  // SpecialDirection
  modSpecialDirectionConfig?: any;

  // SolventSelectionConfig
  modSolventSelectionConfig?: any;

  // mod note
  modNoteData?: any;

  // mod doctor certificate
  modDoctorCertificate?: any;
  modDrugLabInteraction?: any;
  modDrugDisease?: any;
  modDrugInteraction?: any;
  currentDoctor?: any;

  // MedReconcile Check
  medReconcileCheck?: any;
  divisionType?: any;
  medReconcileIndex?: number;
  django?: any;
  isDoctor?: boolean;

  pediatricData?: any;
};

const CardDrugContinuePlanInitial: CardDrugContinuePlanProps = {
  // sequence
  runSequence: null,
  DrugSelectSequence: null,

  // funtion
  onEvent: () => null,
  setProp: () => null,

  // CommonInterface
  errorMessage: null,
  successMessage: null,
  buttonLoadCheck: null,

  // permission
  drugPermission: null,

  // options
  duplicateReasonsOptions: [],

  // selected data
  selectedPatient: null,
  selectedEncounter: null,
  selectedDrug: null,

  // search drug
  drugSearchLoading: false,
  drugSearchText: "",
  drugSearchResult: [],

  // drug list
  drugContinueFilter: {},
  drugContinuePlanItems: [],

  // planning
  modPlanningConfig: null,
  planningData: {},

  // SpecialDirection
  modSpecialDirectionConfig: null,

  // SolventSelectionConfig
  modSolventSelectionConfig: null,

  // mod note
  modNoteData: {},

  // mod doctor certificate
  modDoctorCertificate: {},

  // medReconcile Check
  medReconcileCheck: null,
  divisionType: null,
  medReconcileIndex: -1,
  django: null,
};

const DEFAULT_PROPS = CardDrugContinuePlanInitial

const CardDrugContinuePlan: React.FC<CardDrugContinuePlanProps> = (propsParam: any) => {

  const props = {
    ...DEFAULT_PROPS,
    ...Object.fromEntries(Object.entries(propsParam).filter(([_, value])=> value !== undefined)),
  };

  const intl = useIntl();
  const [dataName, setDataName] = useState("");
  // const [staffRole, setStaffRole] = useState("แพทย์");
  const [checking, setChecking] = useState(false);
  // factsheet
  const [openModFactSheet, setOpenModFactSheet] = useState<boolean>(false);
  const [modDrugDesc, setModDrugDesc] = useState<{
    open?: boolean;
    desc?: string;
    index?: number;
  }>({});
  const [modEditNote, setModEditNote] = useState<{ params?: any; type: string } | null>(null);
  const [modAgeWarn, setModAgeWarn] = useState<string>("");
  const [limitedAge, setLimitedAge] = useState<string>("");
  const [openCalCulator, setOpenCalculator] = useState<boolean>(false);
  const [reasonOptions, setReasonOptions] = useState<any>([]);
  const [prnOptions, setPrnOptions] = useState<any[]>([]);

  const isRequireRate = useMemo(() => {
    const route: any[] = props.masterData?.route || [];

    const foundRoute = route.find((item) => item.id === props.DrugSelectSequence?.route);

    return !!foundRoute?.require_rate;
  }, [props.DrugSelectSequence, props.masterData?.route]);

  // * Default ค่า solvent เมื่อ require rate
  useEffect(() => {
    if (!isRequireRate) {
      return;
    }

    const { params } = prepareModSolventSelection({
      drug: props.DrugSelectSequence,
      drugPermission: props.drugPermission,
      frequency: props.masterData?.frequency,
      noDefaultSolvent: !props.modSolventSelectionConfig?.solvent,
      orderType: "CONTINUE_PLAN",
      solvent: props.modSolventSelectionConfig,
    });

    props.onEvent({
      message: "initModSolventSelection",
      params,
    });
  }, [isRequireRate]);

  useEffect(() => {
    const options = getPrnOptions(props.masterOptions?.prn, props.DrugSelectSequence?.prn);

    if (props.DrugSelectSequence?.code) {
      setPrnOptions([...new Map(options.map((item) => [item.value, item])).values()]);
    } else {
      setPrnOptions([]);
    }
  }, [props.DrugSelectSequence?.code, props.DrugSelectSequence?.prn, props.masterOptions?.prn]);

  useEffect(() => {
    setReasonOptions(props.masterOptions?.drug_limited_age || []);
  }, [props.masterOptions?.drug_limited_age]);

  // Verify
  useEffect(() => {
    console.log("useEffect props.medReconcileCheck: ", props.medReconcileCheck);
    console.log(
      "useEffect props.medReconcileCheck?.open_card_med_reconciliation: ",
      props.medReconcileCheck?.open_card_med_reconciliation
    );
    if (checking && props.medReconcileCheck?.open_card_med_reconciliation === true) {
      setDataName("");
      setChecking(false);
    } else if (checking) {
      console.log(" Called");
      let name = dataName;
      setDataName("");
      setChecking(false);
      props.onEvent({
        message: "NoteAndVerifyAndCancelDrugContinuePlan",
        params: { action: name, note: "", card: CARD_DRUG_CONT_ID },
      });
    }
  }, [props.medReconcileCheck, props.django, props.divisionType]);

  useEffect(() => {
    console.log("Got PediatricDose: ", props.pediatricData?.items);
    if (props.pediatricData?.items?.length > 0) {
      calculateAgeLimited();
    }
    // return () => {
    //   // clean up
    // };
  }, [props.pediatricData]);

  useEffect(() => {
    if (props.pediatricData?.items?.length > 0) {
      calculateAgeLimited();
    }
    // return () => {
    //   // clean up
    // };
  }, [props.DrugSelectSequence?.minimum_age_month]);

  useEffect(() => {
    if (
      props.selectedDrug?.id &&
      props.selectedDrug?.original?.add_auto_solvent &&
      props.modSolventSelectionConfig?.showButtonSolvent
    ) {
      handleOpenModSolventSelection();
    }
  }, [props.modSolventSelectionConfig?.showButtonSolvent, props.selectedDrug?.id]);

  const calculateAgeLimited = () => {
    if (!props.DrugSelectSequence.limited_age) {
      // checking limited_age is calculated
      console.log("calculateAgeLimited ", props.DrugSelectSequence);
      let pYear = parseInt(props.pediatricData?.items[0].patient_age_year);
      let pMonth = parseInt(props.pediatricData?.items[0].patient_age_month);
      let patAge = pYear * 12 + pMonth;

      let dMaxYear = parseInt(props.DrugSelectSequence?.maximum_age_year);
      let dMaxMonth = parseInt(props.DrugSelectSequence?.maximum_age_month);
      let dMax = dMaxYear * 12 + dMaxMonth;

      let dMinYear = parseInt(props.DrugSelectSequence?.minimum_age_year);
      let dMinMonth = parseInt(props.DrugSelectSequence?.minimum_age_month);
      let dMin = dMinYear * 12 + dMinMonth;

      if (patAge > dMax) {
        setModAgeWarn("ผู้ป่วยมีอายุมากกว่าช่วงที่กำหนด");
        props.setProp("DrugSelectSequence.limited_age", "H");
        setLimitedAge("H");
      } else if (patAge < dMin) {
        setModAgeWarn("ผู้ป่วยมีอายุต่ำกว่าช่วงที่กำหนด");
        props.setProp("DrugSelectSequence.limited_age", "L");
        setLimitedAge("L");
      } else {
        props.setProp("DrugSelectSequence.limited_age", "");
        setLimitedAge("");
      }

      console.log("==============================");
      console.log(props.pediatricData);
      console.log("patient age: ", patAge, "month");
      console.log(props.DrugSelectSequence);
      console.log("==============================");
    }
  };

  // Verify
  // useEffect(() => {
  //   console.log("props.django: ", props.django);
  //   console.log("props.divisionType: ", props.divisionType);
  //   console.log("props.selectedEncounter: ", props.selectedEncounter);

  //   if (props.medReconcileCheck) {
  //     if (props.medReconcileCheck?.open_card_med_reconciliation === false) {
  //       let name = dataName;
  //       props.onEvent({
  //         message: "NoteAndVerifyAndCancelDrugContinuePlan",
  //         params: { action: name, note: "", card: CARD_DRUG_CONT_ID },
  //       });
  //       setDataName("");
  //     }
  //   }
  // }, [props.django, props.divisionType, props.medReconcileCheck]);

  // useEffect(() => {
  //   if ((props.django?.user?.role_types || []).includes("PHARMACIST")) {
  //     setStaffRole("เภสัชกร");
  //   } else if ((props.django?.user?.role_types || []).includes("DOCTOR")) {
  //     setStaffRole("แพทย์");
  //   }
  // }, [props.django]);

  useEffect(() => {
    // console.log(" useEffect CardDrugContinuePlan useEffect DrugSelect kick Start ");
    props.runSequence({
      sequence: "DrugSelect", // Start
      card: CARD_DRUG_CONT_ID,
      restart: true,
    });
  }, []);

  const handleCheckHaveQuestion = (data: any) => {
    console.log("handleCheckHaveQuestion data?.item?.claim_payload: ", data?.item?.claim_payload);
    props.onEvent({
      message: "ClaimDrugContinuePlan",
      params: {
        claim_payload: data?.item?.claim_payload,
        product: data.item.drug,
        forceHaveQuestion: data.haveQuestion,
      },
    });
  };

  const handleActionPlanItem =
    (item: any): CallbackHandler =>
    (action, endTime, endDate) => {
      const params = {
        action,
        card: SUB_DRUG_CONT_ACTION_ID,
        end_date: endDate,
        end_time: endTime,
        planItemId: item.plan_item.id,
      };

      if (props.isDoctor) {
        props.onEvent({ message: "handleActionPlanItem", params });
      } else {
        setModEditNote({ params, type: action });
      }
    };

  // useEffect(() => {
  //   if (props.DrugSelectSequence?.sequenceIndex === "START" && !!props.drugContinueFilter?.status) {
  //     handleSetDrugContinueFilter(null, {
  //       name: props.drugContinueFilter?.status,
  //     });
  //   }
  //   return () => {
  //     props.DrugSelectSequence?.drugCPIAbortController?.abort();
  //   };
  // }, [props.DrugSelectSequence?.sequenceIndex]);

  const renderDrugOrderItems = useMemo(() => {
    return props.drugContinuePlanItems?.map((item: any, index: number) => {
      const status =
        item.status === "OFF (VERIFIED)"
          ? `${
              getStatusOff({
                status: "OFF",
                endDate: item.plan_item.end_date,
                endTime: item.plan_item.end_time,
                startDate: item.plan_item.start_date,
              }).status
            } (${"Verified"})`.toUpperCase()
          : item.status.search(/VERIFIED.*Plan Off/g) >= 0
          ? "PLAN OFF (VERIFIED)"
          : item.status;

      return {
        ...item,
        title_status: (
          <>
            {item.isSolvent ? (
              item.solvent_product_full_name
            ) : (
              <SubDrugNameFormat
                onEvent={props.onEvent}
                name={item.drug_name_from_format}
                product={item.drug}
              />
            )}
            {item?.individual_use && (
              <label style={{ color: "red", fontSize: "12px", paddingLeft: "10px" }}>
                {intl.formatMessage({ id: "(ยาสำหรับผู้ป่วยเฉพาะราย)" })}
              </label>
            )}
            <div style={{ display: "flex" }}>
              {!item.isSolvent && (
                <>
                  {item.is_external && (
                    <Label color="yellow" size="mini">
                      own med
                    </Label>
                  )}
                  <Icon
                    name="history"
                    style={{ margin: "0 0.275rem", cursor: "pointer" }}
                    onClick={() => {
                      props.setProp("DrugSelectSequence.actionLogs.open", true);
                    }}
                  />
                </>
              )}

              <SubDrugOrderStatusAlert
                onEvent={props.onEvent}
                stateKey="drugOrder"
                index={index}
                item={{
                  ...item,
                  alerts: {
                    N: item?.order_notes,
                    X: item?.reject_note,
                    ...(item.alerts || {}),
                  },
                  pregcat: item?.alerts?.pregcat_alert,
                  pregcat_alert: item?.alerts?.pregcat,
                  claim_result:
                    item.claim_payload?.claim_results?.length > 0
                      ? item.claim_payload.claim_results[0]?.claim_result
                      : null,
                }}
                saveClaimByEvent={true}
                estimate={{
                  ...item.claim_payload,
                }}
                selectedEncounter={props.selectedEncounter}
                selectedEmr={props.selectedEmr}
                orderType={DRUG_ORDER_TYPE}
                selectedProgressCycle={props.selectedProgressCycle}
                isFemale={props.selectedEncounter?.patient_gender_name === "Female"}
                targetStateOrder={"drugContinuePlanItems"}
                //  onSaveNote={handleSaveNote}
                // callback
                onDrugClaim={(data: any) => handleCheckHaveQuestion(data)}
                useOutSideCardQAClaim={true}
                languageUX={props.languageUX}
              />
            </div>
          </>
        ),
        action: (
          <div
            style={{
              position: "absolute",
              display: "flex",
              justifyContent: "center",
              width: "100%",
              ...(item.isDrugAdmixture && { bottom: "-15px", zIndex: "1" }),
            }}
          >
            {!item.isSolvent &&
              (item.plan_item?.allowed_actions?.includes("RESUME") ||
                item.plan_item?.allowed_actions?.includes("OFF") ||
                item.plan_item?.allowed_actions?.includes("HOLD") ||
                item.plan_item?.allowed_actions?.includes("RENEW")) && (
                // <ActionMenuColumn
                //   onEvent={props.onEvent}
                //   setProp={props.setProp}
                //   buttonLoadCheck={props.buttonLoadCheck}
                //   plan_item={item?.plan_item}
                // />
                <ActionMenuColumn
                  setProp={props.setProp}
                  actions={["RESUME", "OFF", "HOLD", "RENEW"]}
                  cardId={SUB_DRUG_CONT_ACTION_ID}
                  buttonLoadCheck={props.buttonLoadCheck}
                  item={item}
                  date={moment()}
                  getButtonStyle={(action) => ({
                    display: item.plan_item?.allowed_actions?.includes(action) ? "" : "none",
                  })}
                  onCallback={handleActionPlanItem(item)}
                />
                // <ActionMenuColumn
                //   setProp={props.setProp}
                //   actions={["RESUME", "OFF", "HOLD", "RENEW"]}
                //   cardId={SUB_DRUG_CONT_ACTION_ID}
                //   buttonLoadCheck={props.buttonLoadCheck}
                //   getButtonStyle={(action) => ({
                //     display: item.plan_item?.allowed_actions?.includes(action) ? "" : "none",
                //   })}
                //   onCallback={(action) => {
                //     props.onEvent({
                //       message: "handleActionPlanItem",
                //       params: {
                //         action,
                //         card: SUB_DRUG_CONT_ACTION_ID,
                //         planItemId: item.plan_item.id,
                //       },
                //     });
                //   }}
                // />
              )}
          </div>
        ),
        routeText: item.isSolvent ? (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              height: "98%",
            }}
          >
            สำหรับผสม {item.drug_name_from_format}
          </div>
        ) : (
          <>
            {item.routeText}
            {!!Number(item.mixture_iv_rate) && (
              <>
                <div>
                  Drip Rate : {Number(item.mixture_iv_rate)} {item.mixtureIvRateUnit}
                </div>
              </>
            )}
            {!!Number(item.drug_drip_in) && (
              <>
                <div>
                  Drip Duration : {Number(item.drug_drip_in)} {item.drugDripInUnit}
                </div>
              </>
            )}
          </>
        ),
        status,
        _status: (
          <div
            style={
              item.isDrugAdmixture
                ? {
                    position: "absolute",
                    bottom: status.includes("OFF") ? "-21px" : "-9px",
                    zIndex: "1",
                  }
                : {}
            }
          >
            {!item.isSolvent && status}
          </div>
        ),
        qty: item.sending_quantity || item.calculated_daily_quantity?.replace(/\/.*$/, ""),
        frequencyText: item.description
          ? item?.frequencyText?.replaceAll(`${item.description}`, `\n${item.description}`)
          : item?.frequencyText,
      };
    });
  }, [props.drugContinuePlanItems, props.buttonLoadCheck]);

  // const renderDrugItemSearchResult = useMemo(() => {
  //   return (props.drugSearchResult || []).map((drug: any) => ({
  //     ...drug,
  //     generic_name: htmlParse(drug.generic_name || ""),
  //   }));
  // }, [props.drugSearchResult]);

  const buttonActions = useMemo(() => {
    let roleTypes = props.django?.user?.role_types || [];

    const isPharmacist = roleTypes.includes("PHARMACIST");

    const showCancel =
      props.DrugSelectSequence?.allowed_actions?.includes("CANCEL") &&
      props.drugPermission?.action_TPD_DrugContinuePlan_CANCEL;

    const showReject =
      props.DrugSelectSequence?.allowed_actions?.includes("REJECT") &&
      props.drugPermission?.action_TPD_DrugContinuePlan_REJECT;

    const showVerify =
      props.DrugSelectSequence?.allowed_actions?.includes("VERIFY") &&
      props.drugPermission?.action_TPD_DrugContinuePlan_VERIFY;

    return {
      cancel: {
        show: showCancel & isPharmacist,
      },
      reject: {
        show: showReject & isPharmacist,
      },
      verify: {
        show: showVerify & isPharmacist,
      },
    };
  }, [props.DrugSelectSequence?.allowed_actions, props.drugPermission, props.django?.user]);

  // filter
  const handleSetDrugContinueFilter = (_event: any, data: any) => {
    props.onEvent({
      message: "SetDrugContinueFilter",
      params: { status: data.name },
    });
  };

  // Action DrugContinuePlan
  const handleClearDrugOrderForm = () => {
    props.onEvent({ message: "ClearDrugOrderForm", params: { hard: true } });
  };

  const previewDrugContinuePlan = (data: any) => {
    props.onEvent({
      message: "PreviewDrugContinuePlan",
      params: {
        name: data.name,
        value: data.value,
        card: CARD_DRUG_CONT_ID,
      },
    });
  };

  const previewDrugContinuePlanDebounce = useCallback(
    _.debounce(previewDrugContinuePlan, 2000, { trailing: true }),
    []
  );

  const handlePreviewDrugContinuePlan = (event: any, data: any) => {
    const route: any[] = props.masterData?.route || [];
    const frequency: any[] = props.masterData?.frequency || [];

    const foundRoute = route.find((item) => item.id === data.value);
    const foundFrequency = frequency.find((item) => item.id === data.value);

    if (!foundRoute?.require_rate && data.name === "route") {
      props.setProp("modSolventSelectionConfig", {
        ...props.modSolventSelectionConfig,
        dripRate: null,
        drug_drip_in: null,
        drug_drip_in_unit: null,
        mixture_iv_rate: null,
        mixture_iv_rate_unit: null,
      });
    } else if (
      data.name === "frequency" &&
      props.modSolventSelectionConfig?.activeButtonSolvent &&
      props.modSolventSelectionConfig?.solvent
    ) {
      props.setProp("modSolventSelectionConfig", {
        ...props.modSolventSelectionConfig,
        quantity: foundFrequency?.dose_per_day,
      });
    }

    if (["dose", "sending_interval"].includes(data.name)) {
      props.setProp(`DrugSelectSequence.${data.name}`, data.value);
      previewDrugContinuePlanDebounce(data);
    } else {
      previewDrugContinuePlan(data);
    }
  };

  const handleUnPreviewDrugContinuePlan = (_event: any, data: any) => {
    props.setProp(`DrugSelectSequence.${data.name}`, data.value);
    if (data.name === 'sending_interval' && data.value > 1) {
      props.setProp(`planningData`, {
        ...props.planningData, day_take: 1, day_skip: data.value
      });
    } else if (data.name === 'sending_interval') {
      props.setProp(`planningData`, {
        ...props.planningData, day_take: null, day_skip: null
      });
    }
  };

  const handleSave = (_event: any, data: any) => {
    // TODO : Issue 59228
    // Check Generics then Check Drug group
    if (data.name === "REQUEST") {
      let params = {
        action: data.name,
        card: CARD_DRUG_CONT_ID,
        orderType: "CONTINUE_PLAN",
      };

      if (props.isDoctor) {
        params.order_type = "DIRECT"
        props.onEvent({
          message: "SaveSolventData",
          params: {
            drugOrderType: props.orderType,
            isRequireRate,
            onSuccess: () => {
              props.onEvent({ message: "CheckDrugGroupDuplicate", params });
            },
          },
        });
      } else {
        setModEditNote({ params, type: data.name });
      }
    } else {
      props.onEvent({
        message: "ConfirmDrugContinueOrder",
        params: {
          action: data.name,
          card: CARD_DRUG_CONT_ID,
          isCheckDrugGroup: true,
          // order_type: props.isDoctor ? "DIRECT" : undefined
          order_type: "DIRECT"
        },
      });
    }
  };

  const handleConfirmDrugGroupDuplicateWithReason = (reason: any) => {
    if (reason?.duplicated_note) {
      props.onEvent({
        message: "ConfirmDrugContinueOrder",
        params: {
          action: "REQUEST",
          card: CARD_DRUG_CONT_ID,
          isCheckDrugGroup: true,
          noteGroupDuplicated: reason?.duplicated_note,
          order_type: "DIRECT"
          // order_type: props.isDoctor ? "DIRECT" : undefined
        },
      });
    }
  };

  const handleConfirm = (data: any) => {
    const error = props.errorMessage?.[CARD_DUPLICATE_REASON];
    return props.onEvent({
      message: error?.message || "ConfirmDrugContinueOrder",
      params: {
        card: CARD_DRUG_CONT_ID,
        action: error?.action,
        ...(error?.noteGroupDuplicated && {
          noteGroupDuplicated: error?.noteGroupDuplicated,
        }),
        ...data,
        first_duplicated_item: error?.first_duplicated_item,
        confirm_duplicated_drugs: true,
      },
    });
  };

  const handleEditDrugContinuePlan = (_event: any, data: any) => {
    props.onEvent({
      message: "EditDrugContinuePlan",
      params: { action: data.name, card: CARD_DRUG_CONT_ID },
    });

    handleCloseModEditNote();
  };

  const handleCheckEditDrugContinuePlan = (event: any, data: any) => {
    props.onEvent({
      message: "SaveSolventData",
      params: {
        drugOrderType: props.orderType,
        isRequireRate,
        onSuccess: () => {
          if (props.isDoctor) {
            handleEditDrugContinuePlan(event, data);
          } else {
            setModEditNote({ type: data.name });
          }
        },
      },
    });
  };

  const handleCloseModEditNote = () => {
    setModEditNote(null);

    // #props.setProp("DrugSelectSequence.note", "");
  };

  const handleNoteAndVerifyAndCancelDrugContinuePlan = (_event: any, data: any) => {
    // TODO: call MedReconcile

    console.log("handleNoteAndVerifyAndCancelDrugContinuePlan: ");
    let roleTypes = props.django?.user?.role_types;
    console.log("handleSaveModNote roleTypes: ", roleTypes);
    console.log("handleSaveModNote props.divisionType", props.divisionType);
    if (["ห้องยา"].includes(props.divisionType) && (roleTypes || []).includes("PHARMACIST")) {
      let callFrom = "TPD";
      if (props.selectedEncounter?.id) {
        setChecking(true);
        setDataName(data?.name);
        props.onEvent({
          message: "GetMedReconcileCheck",
          params: { encounter: props.selectedEncounter, callForm: callFrom },
        });
      }
      return;
    } else {
      console.warn("ไม่ได้มาจาก ห้องจ่ายยา เปิด CardDrugContinuePlan: ");
    }

    // console.log('handleNoteAndVerifyAndCancelDrugContinuePlan data.name: ', data.name);

    // props.onEvent({
    //   message: "NoteAndVerifyAndCancelDrugContinuePlan",
    //   params: { action: data.name, note: "", card: CARD_DRUG_CONT_ID },
    // });
  };

  // Mod Note
  const handleChangeModNoteData = (_event: any, data: any) => {
    props.onEvent({
      message: "SetModNoteData",
      params: { name: data.name, value: data.value },
    });
  };

  const handleSaveModNote = (goToMedreconcile: boolean = false) => {
    console.log("handleSaveModNote: ", goToMedreconcile);

    if (goToMedreconcile) {
      let roleTypes = props.django?.user?.role_types;
      console.log("handleSaveModNote roleTypes: ", roleTypes);
      console.log("handleSaveModNote props.divisionType", props.divisionType);
      if (["ห้องยา"].includes(props.divisionType) && (roleTypes || []).includes("PHARMACIST")) {
        let callFrom = "TPD";
        if (props.selectedEncounter?.id) {
          props.onEvent({
            message: "GetMedReconcileCheck",
            params: { encounter: props.selectedEncounter, callForm: callFrom },
          });
        }
      } else {
        console.warn("ไม่ได้มาจาก ห้องจ่ายยา เปิด CardDrugContinuePlan: ");
      }
    } else {
      props.onEvent({
        message: "NoteAndVerifyAndCancelDrugContinuePlan",
        params: { card: CARD_DRUG_CONT_ID },
      });
    }
  };

  const handleCloseModNote = () => {
    props.setProp("modNoteData", { open: false });
  };

  // Mod Planning
  const handleOpenModPlanning = () => {
    if (props.errorMessage?.[CARD_DRUG_CONT_ID]?.error) {
      props.setProp(`errorMessage.${CARD_DRUG_CONT_ID}.showMessage`, true);
    } else {
      if (props.planningData?.id) {
        // fetch /apis/core/plan-item/<id>/
      } else {
        props.onEvent({ message: "handleSetDefaultPlanningData" });
      }
      props.onEvent({
        message: "handleSetModPlanningConfig",
        params: { name: "open", value: true },
      });
    }
  };

  const handleCloseModPlanning = () => {
    props.onEvent({
      message: "handleSetModPlanningConfig",
      params: { name: "open", value: false },
    });
    // props.onEvent({ message: "GetDrugContinuePlan" });
  };

  // Mod Special Direction
  const handleOpenModSpecialDirection = () => {
    props.onEvent({
      message: "SetModSpecialDirectionConfig",
      params: { name: "open", value: true },
    });
  };

  const handleCloseModSpecialDirection = () => {
    props.onEvent({
      message: "SetModSpecialDirectionConfig",
      params: { name: "open", value: false },
    });
  };

  // Mod Solvent Selection
  const handleOpenModSolventSelection = async () => {
    // let admixtureOptions: any = {};
    // if (props.drugPermission.config_TPD_ENABLE_IV_COMPATIBLE) {
    //   admixtureOptions = {
    //     quantity: props.DrugSelectSequence?.solvent_quantity,
    //     strength: props.DrugSelectSequence?.dose || 1,
    //     strength_unit: props.DrugSelectSequence?.unit || "",
    //     volume: props.DrugSelectSequence?.mixture_solvent_volume,
    //     mixture_iv_rate: props.DrugSelectSequence?.mixture_iv_rate,
    //     mixture_iv_rate_unit: props.DrugSelectSequence?.mixture_iv_rate_unit,
    //     solute_concentration_rate: props.DrugSelectSequence?.mixture_concentration_solute,
    //     solvent_concentration_rate: props.DrugSelectSequence?.mixture_concentration_solvent,
    //     concentration_unit: props.DrugSelectSequence?.drug_concentration_unit,
    //     drug_drip_in: props.DrugSelectSequence?.drug_drip_in,
    //     drug_drip_in_unit: props.DrugSelectSequence?.drug_drip_in_unit,
    //   };

    //   const editable: boolean =
    //     props.DrugSelectSequence?.allowed_actions?.includes("REQUEST") ||
    //     props.DrugSelectSequence?.allowed_actions?.includes("EDIT");
    //   props.onEvent({
    //     message: "SetModSolventSelectionConfig",
    //     params: { editable: editable, editableQuantity: editable },
    //   });
    // } else {
    //   admixtureOptions = {
    //     quantity: props.DrugSelectSequence?.solvent_quantity,
    //     rate: props.DrugSelectSequence?.mixture_iv_rate,
    //   };
    // }
    // props.onEvent({
    //   message: "initModSolventSelection",
    //   params: {
    //     drugOrderType: DRUG_ORDER_TYPE,
    //     solventId: props.DrugSelectSequence?.solvent_product,
    //     admixtureOptions: admixtureOptions,
    //   },
    // });

    const data = props.modSolventSelectionConfig;
    const active = data?.activeButtonSolvent;
    const isEdit = typeof data?.admixtureIndex === "number";

    if (active || isEdit) {
      return;
    }

    await props.onEvent({
      message: "SetModSolventSelectionConfig",
      params: { activeButtonSolvent: true, editable: true, editableQuantity: true },
    });

    const { params } = prepareModSolventSelection({
      drug: props.DrugSelectSequence,
      drugPermission: props.drugPermission,
      frequency: props.masterData?.frequency,
      orderType: "CONTINUE_PLAN",
      solvent: props.modSolventSelectionConfig,
    });

    props.onEvent({
      message: "initModSolventSelection",
      params,
    });
  };

  // const handleCloseModSolventSelection = () => {
  //   props.onEvent({
  //     message: "SetModSolventSelectionConfig",
  //     params: { openModal: false },
  //   });
  // };

  const handleSaveDrugClaimQA = (claim_payload: any, idx: number) => {
    console.groupCollapsed("handleSaveDrugClaimQA");
    // console.log('handleSaveDrugClaimQA _index: ', _index);
    console.log("handleSaveDrugClaimQA claim_payload: ", claim_payload);
    let drugSelectSeq: any = props.DrugSelectSequence;
    console.log("handleSaveDrugClaimQA props.DrugSelectSequence:", props.DrugSelectSequence);

    let claimPayload: any = { ...drugSelectSeq?.claim_payload };
    claimPayload.payloads[0].answer_dict = claim_payload?.payloads?.[0]?.answer_dict;
    let product = claim_payload?.selectedProduct;
    console.log("handleSaveDrugClaimQA claimPayload: ", claimPayload);
    console.log("!!!!!!!! PRODUCT !!!!!!!! handleSaveDrugClaimQA product: ", product);
    console.groupEnd();
    props.onEvent({
      message: "ClaimDrugContinuePlan",
      params: {
        claim_payload: claimPayload,
        product: product || claim_payload?.payloads?.[0]?.product_id,
      },
    });
  };

  const handleClickDrugFact = () => {
    setOpenModFactSheet(true);
  };

  const handleOpenModDrugDesc = () => {
    setModDrugDesc({ open: true, desc: props.DrugSelectSequence?.description });
  };

  const handleCloseFactSheet = () => {
    setOpenModFactSheet(false);
  };

  const handleCloseModDesc = () => {
    setModDrugDesc({});
  };

  const handleConfirmDesc = (description: string) => {
    handlePreviewDrugContinuePlan(null, {
      name: "description",
      value: description,
    });

    handleCloseModDesc();
  };

  const handleSelectDrug = (rowInfo: RowInfo) => {
    if (props.DrugSelectSequence?.disabledClickSearchDrugTable) {
      console.log("Already Selected");

      return;
    }

    props.runSequence({
      sequence: "DrugSelect",
      selectedDrug: rowInfo.original,
      card: CARD_DRUG_CONT_ID,
    });

    props.onEvent({
      message: "GetPediatricDose",
      params: {
        action: "LIST",
        drugDetail: rowInfo.original,
        card: CARD_DRUG_CONT_ID,
      },
    });
  };

  const enableCalculatorButton = useMemo(() => {
    if (props.pediatricData?.items?.length > 0) {
      return true;
    } else {
      return false;
    }
  }, [props.pediatricData]);

  // change
  const handleChangeModData = (event: any, data: any) => {
    if (data.type === "number" && Number(data.value) < 0) {
      data.value = "0";
    }

    props.onEvent({
      message: "SetModSolventSelectionData",
      params: { name: data.name, value: data.value },
    });
  };

  const handleSelectedSolvent: SelectedItemHandler = (value) => {
    if (!value) {
      props.setProp("DrugSelectSequence", {
        ...props.DrugSelectSequence,
        ...INITIAL_SOLVENT_ADR,
      });

      props.setProp("modSolventSelectionConfig", {
        ...props.modSolventSelectionConfig,
        ...INITIAL_SOLVENT_DATA,
      });

      return;
    }

    props.onEvent({
      message: "GetDrugSolventDetail",
      params: { id: value, orderType: "CONTINUE_PLAN" },
    });
  };

  const handleCloseButtonSolvent = () => {
    props.setProp("DrugSelectSequence", {
      ...props.DrugSelectSequence,
      ...INITIAL_SOLVENT_ADR,
    });

    props.setProp("modSolventSelectionConfig", {
      ...props.modSolventSelectionConfig,
      activeButtonSolvent: false,
      ...INITIAL_SOLVENT_DATA,
    });
  };

  const handleEditSolvent = async (solvent: any, index: number) => {
    await props.onEvent({
      message: "SetModSolventSelectionConfig",
      params: {
        editable: true,
        editableQuantity: true,
        openModal: true,
        admixtureIndex: index,
        activeButtonSolvent: solvent.solvent_product,
      },
    });

    const admixtureOptions: any = {
      volume: solvent?.mixture_solvent_volume || solvent?.volume || "",
      quantity: solvent?.solvent_quantity,
      mixture_iv_rate: Number.parseInt(solvent?.mixture_iv_rate),
      mixture_iv_rate_unit: solvent?.mixture_iv_rate_unit || "",
      drug_drip_in: solvent?.drug_drip_in || "",
      drug_drip_in_unit: solvent?.drug_drip_in_unit || "",
      unit: solvent?.mixture_solvent_volume_unit || "",
    };

    await props.onEvent({
      message: "initModSolventSelection",
      params: {
        admixtureOptions,
        drugOrderType: "CONTINUE_PLAN",
        solvent: {
          id: solvent?.solvent_product,
          full_name: solvent?.solvent_product_full_name,
          label_name: solvent?.solvent_product_full_name,
        },
      },
    });
  };

  const handleDrugListProps = (state: any, rowInfo: any, _column: any, _instance: any) => {
    const original = rowInfo?.original || {};
    let isRequested = original.status === "REQUESTED";
    let isSelected: boolean =
      props.DrugSelectSequence?.id && original.id === props.DrugSelectSequence?.id;
    return {
      style: {
        ...(isRequested && !isSelected && { backgroundColor: "#ffffcc" }),
        cursor: props.DrugSelectSequence?.drugDetailLoading ? "wait" : "pointer",
      },
      className:
        props.DrugSelectSequence?.id && original.id === props.DrugSelectSequence?.id
          ? "blueSelectedRow"
          : "",
      onClick: () => {
        if (!props.DrugSelectSequence?.drugDetailLoading) {
          // console.log("drugListProps: SetDrugContinuePlan called ");
          if (props.DrugSelectSequence?.id === original.id) {
            // deselect
            props.onEvent({
              message: "ClearDrugOrderForm",
            });
          } else {
            const data = original.isSolvent ? original.original : original;
            const index = original.isSolvent ? original.index : rowInfo.index;

            handleEditSolvent({ ...data }, index);

            // select
            props.onEvent({
              message: "SetDrugContinuePlan",
              params: data,
            });
          }
        } else {
          // console.log("drugListProps: SetDrugContinuePlan not called");
        }
      },
    };
  };

  const handleMouseEnter = (
    event: React.MouseEvent<HTMLTableRowElement, MouseEvent>,
    isDrugAdmixture: boolean,
    isSolvent: boolean
  ) => {
    const row = event.currentTarget;
    row.classList.add("linked-row");

    const nextRow = row.nextElementSibling as HTMLTableRowElement | null;
    const prevRow = row.previousElementSibling as HTMLTableRowElement | null;

    if (isDrugAdmixture && nextRow) {
      nextRow.classList.add("linked-row");
    } else if (isSolvent && prevRow) {
      prevRow.classList.add("linked-row");
    }
  };

  const handleMouseLeave = (event: React.MouseEvent<HTMLTableRowElement, MouseEvent>) => {
    const row = event.currentTarget;
    row.classList.remove("linked-row");

    const nextRow = row.nextElementSibling as HTMLTableRowElement | null;
    const prevRow = row.previousElementSibling as HTMLTableRowElement | null;

    if (nextRow) {
      nextRow.classList.remove("linked-row");
    }

    if (prevRow) {
      prevRow.classList.remove("linked-row");
    }
  };

  const handleDrugItemsTrGroupProps = (state: any, rowInfo: any) => {
    const original = rowInfo?.original || {};

    return {
      // className: original.isDrugAdmixture || original.isSolvent ? "linked-row" : "",
      style: {
        // borderBottom: original.isDrugAdmixture ? 0 : "",
        lineHeight: 1.5,
        borderBottom: 0,
      },
      onMouseEnter: (event: any) =>
        handleMouseEnter(event, original.isDrugAdmixture, original.isSolvent),
      onMouseLeave: handleMouseLeave,
    };
  };

  const handleDrugItemsTdProps = (state: any, rowInfo: any, column: any) => {
    const original = rowInfo?.original || {};
    const isDrugAdmixture = !!original.isDrugAdmixture && !original.isSolvent;
    const borderBottom =
      ["action", "_status"].includes(column.id) && isDrugAdmixture
        ? ""
        : "solid 1px rgba(0,0,0,0.05)";

    if (original.isSolvent) {
      if (column.id === "routeText") {
        return {
          colSpan: 4,
          style: {
            borderBottom,
            minWidth: "530px", // Adjust this value as needed
          },
        };
      } else if (["frequencyText", "siteText", "prn"].includes(column.id)) {
        return { style: { display: "none", borderBottom } };
      }
    }

    return {
      style: { borderBottom, overflow: "unset", position: "relative" },
    };
  };

  const handleEditQuantity = (event: any, data: any) => {
    if (props.isDoctor) {
      handleEditDrugContinuePlan(event, data);
    } else {
      setModEditNote({ type: data.name });
    }
  };

  const handleSaveEditNote = (e: SyntheticEvent, data: ButtonProps) => {
    if (data.name === "REQUEST") {
      props.onEvent({
        message: "CheckDrugGroupDuplicate",
        params: modEditNote?.params,
      });

      handleCloseModEditNote();
    } else if (["RESUME", "OFF", "HOLD", "RENEW"].includes(data.name)) {
      props.onEvent({ message: "handleActionPlanItem", params: modEditNote?.params });

      handleCloseModEditNote();
    } else {
      handleEditDrugContinuePlan(null, data);
    }
  };

  const handleAddPrn = (e: SyntheticEvent, v: any) => {
    setPrnOptions([...prnOptions, { key: v.value, text: v.value, value: v.value }]);
  };

  console.log("CardDrugContinuePlan props: ", props);
  return (
    <div id="ContinueMed" style={{ width: "100%", height: "100%" }}>
      {props.errorMessage?.[CARD_DRUG_CONT_ID]?.showMessage &&
        props.errorMessage?.[CARD_DRUG_CONT_ID]?.error && (
          <SnackMessage
            onEvent={props.onEvent}
            onClose={() => {
              props.setProp(`errorMessage.${CARD_DRUG_CONT_ID}.showMessage`, false);
            }}
            error={props.errorMessage?.[CARD_DRUG_CONT_ID]?.error}
            success={props.successMessage?.[CARD_DRUG_CONT_ID]}
            languageUX={props.languageUX}
          />
        )}

      <SnackMessage
        onEvent={props.onEvent}
        error={props.errorMessage?.[MOD_SOLVENT_SELECTION_ID]}
        success={null}
        onClose={() => {
          props.setProp(`errorMessage.${MOD_SOLVENT_SELECTION_ID}`, null);
        }}
        languageUX={props.languageUX}
      />

      <SnackMessage
        onEvent={props.onEvent}
        onClose={() => {
          props.setProp(`modPlanningConfig.error`, null);
        }}
        error={props.modPlanningConfig?.error}
        success={null}
        languageUX={props.languageUX}
      />

      <CardDrugContinuePlanUX
        // seq
        DrugSelectSequence={props.DrugSelectSequence}
        // permission
        drugPermission={props.drugPermission}
        // filter
        onSetdrugContinueFilter={handleSetDrugContinueFilter}
        drugContinueFilter={props.drugContinueFilter}
        // drug list
        drugContinuePlanItems={renderDrugOrderItems}
        // getDrugListTdProps={(state: any, rowInfo: any, column: any, instance: any) => {
        //   return {
        //     onClick: () => {
        //       console.log("onClick getDrugListTdProps : ", state, rowInfo, column, instance);
        //       if (rowInfo === undefined) {
        //         props.onEvent({
        //           message: "ClearDrugOrderForm",
        //         });
        //       }
        //     },
        //   };
        // }}
        // drugListProps={}
        buttonActions={buttonActions}
        // Master
        drugUnits={props.DrugSelectSequence?.drugUnits || []}
        drugRoutes={props.DrugSelectSequence?.drugRoutes || []}
        drugSites={props.DrugSelectSequence?.drugSites || []}
        drugFrequencies={props.DrugSelectSequence?.drugFrequencies || []}
        drugMethods={props.DrugSelectSequence?.drugMethods || []}
        prnOptions={prnOptions}
        standardAdminTimeOptions={props.DrugSelectSequence?.standardAdminTimeOptions || []}
        hasFactsheetData={!!Object.keys(props.DrugSelectSequence?.factsheet_data || {}).length}
        hidePanel={props.DrugSelectSequence?.drugContinuePlanLoading}
        hideDrugDescription={
          !(
            (props.DrugSelectSequence?.drugFrequencies || [])
              .find((option: any) => option.value === props.DrugSelectSequence?.frequency)
              ?.text?.search(/\(UD\)$/g) >= 0
          )
        }
        onClickDrugFact={handleClickDrugFact}
        onDrugDescription={handleOpenModDrugDesc}
        //  planning
        onOpenModPlanning={handleOpenModPlanning}
        planningData={props.planningData}
        // SpecialDirection
        onOpenModSpecialDirection={handleOpenModSpecialDirection}
        modSpecialDirectionConfig={props.modSpecialDirectionConfig}
        // SolventSelection
        onOpenModSolventSelection={handleOpenModSolventSelection}
        modSolventSelectionConfig={props.modSolventSelectionConfig}
        isRequireRate={isRequireRate}
        hideSolvent={!props.modSolventSelectionConfig?.activeButtonSolvent}
        unitOptions={props.masterOptions?.unit}
        onChangeModData={handleChangeModData}
        onCloseButtonSolvent={handleCloseButtonSolvent}
        dripDurationLabel={
          <CustomRadioButton
            checked={props.modSolventSelectionConfig?.dripRate === "drip"}
            label="Drip Duration"
            labelStyle={{ fontWeight: "normal" }}
            name="dripRate"
            showHeader={props.showHeader}
            value="drip"
            onChange={handleChangeModData}
          />
        }
        dripRateLabel={
          <CustomRadioButton
            checked={props.modSolventSelectionConfig?.dripRate === "rate"}
            label="Drip Rate"
            labelStyle={{ fontWeight: "normal" }}
            name="dripRate"
            showHeader={props.showHeader}
            value="rate"
            onChange={handleChangeModData}
          />
        }
        searchBoxSolvent={
          <SearchBoxDropdown
            onEvent={props.onEvent}
            id="EMO"
            icon="search"
            limit={20}
            selectedItem={props.modSolventSelectionConfig?.solvent || null}
            style={{ width: "100%" }}
            // config
            type="Drug"
            fluid
            inline
            useWithKey
            searchedItemListWithKey={props.searchedItemListWithKey}
            setSelectedItem={handleSelectedSolvent}
            onAdditionalUrlParams={(searchQuery) => ({
              keyword: undefined,
              name: searchQuery,
              solvent_for: props.selectedDrug?.id,
            })}
          />
        }
        // function
        onClearDrugOrderForm={handleClearDrugOrderForm}
        loadingPreviews={!!props.DrugSelectSequence?.loadingPreviews}
        onPreviewDrugContinuePlan={handlePreviewDrugContinuePlan}
        onUnPreviewDrugContinuePlan={handleUnPreviewDrugContinuePlan}
        onAdditionPrn={handleAddPrn}
        // onSave={handleSave}
        onEditDrugContinuePlan={handleEditDrugContinuePlan}
        onNoteAndVerifyAndCancelDrugContinuePlan={handleNoteAndVerifyAndCancelDrugContinuePlan}
        // component
        drugSearchBox={
          <DrugSearchBox
            onEvent={props.onEvent}
            setProp={props.setProp}
            // data
            drugSearchText={props.drugSearchText}
            // statusRequest={statusRequested}
            selectedDrug={props.selectedDrug}
            drugSearchResult={props.drugSearchResult}
            drugSearchLoading={props.drugSearchLoading}
            // config
            disabled={
              !props.DrugSelectSequence?.id
                ? false
                : props.DrugSelectSequence?.id &&
                  (props.DrugSelectSequence?.allowed_actions?.includes("REQUEST") ||
                    props.DrugSelectSequence?.allowed_actions?.includes("EDIT"))
                ? false
                : true
            }
            trStyle={{
              cursor: props.DrugSelectSequence?.disabledClickSearchDrugTable ? "wait" : "pointer",
            }}
            onSelect={handleSelectDrug}
          />
        }
        // noDataComponent={() => {
        //   console.log(
        //     " noDataComponent props.DrugSelectSequence?.drugContinuePlanLoading:",
        //     props.DrugSelectSequence?.drugContinuePlanLoading
        //   );
        //   if (props.DrugSelectSequence?.drugContinuePlanLoading) {
        //     return <Loader active />;
        //   } else {
        //     return null;
        //   }
        // }}
        drugContinuePlanLoading={props.DrugSelectSequence?.drugContinuePlanLoading}
        tableElement={
          <Table
            NoDataComponent={() => {
              return props.DrugSelectSequence?.drugContinuePlanLoading ? <Loader active /> : null;
            }}
            data={renderDrugOrderItems}
            // getTdProps={props.getDrugListTdProps}
            getTrProps={handleDrugListProps}
            getTrGroupProps={handleDrugItemsTrGroupProps}
            getTdProps={handleDrugItemsTdProps}
            headers="Drug, Dose, Unit, Route, Site, Frequency,PRN, Qty, Status, Action"
            keys="title_status, dose, unitText, routeText, siteText, frequencyText,prn, qty, _status,action"
            minRows="10"
            showPagination={false}
            style={{ height: "45vh", padding: "0 5px" }}
            widths="^150,^60,90,170,110,130,120,^70,^90,75"
          />
        }
        buttonEdit={
          <ButtonLoadCheck
            // function
            setProp={props.setProp}
            onClick={handleCheckEditDrugContinuePlan}
            // data
            paramKey={`${CARD_DRUG_CONT_ID}_EDIT`}
            buttonLoadCheck={props.buttonLoadCheck?.[`${CARD_DRUG_CONT_ID}_EDIT`]}
            // config
            color="yellow"
            name="EDIT"
            size="small"
            style={{
              display:
                props.DrugSelectSequence?.allowed_actions?.includes("EDIT") &&
                props.drugPermission?.action_TPD_DrugContinuePlan_EDIT
                  ? ""
                  : "none",
            }}
            title="EDIT"
          />
        }
        buttonEditQuantity={
          <ButtonLoadCheck
            // function
            setProp={props.setProp}
            onClick={handleEditQuantity}
            // data
            paramKey={`${CARD_DRUG_CONT_ID}_EDIT_QUANTITY`}
            buttonLoadCheck={props.buttonLoadCheck?.[`${CARD_DRUG_CONT_ID}_EDIT_QUANTITY`]}
            // config
            color="yellow"
            name="EDIT_QUANTITY"
            size="small"
            style={{
              display:
                props.DrugSelectSequence?.allowed_actions?.includes("EDIT_QUANTITY") &&
                props.drugPermission?.action_TPD_DrugContinuePlan_EDIT_QUANTITY
                  ? ""
                  : "none",
            }}
            title="EDIT QUANTITY"
          />
        }
        buttonRequest={
          <ButtonLoadCheck
            // disabled1
            disabled={
              props.DrugSelectSequence?.loadingPreviews ||
              !props.DrugSelectSequence?.selectedDrug ||
              !props.DrugSelectSequence?.dose ||
              !props.DrugSelectSequence?.unit ||
              !props.DrugSelectSequence?.route ||
              // !props.DrugSelectSequence?.method ||
              !props.DrugSelectSequence?.frequency
            }
            // function
            setProp={props.setProp}
            onClick={handleSave}
            // data
            paramKey={`${CARD_DRUG_CONT_ID}_REQUEST`}
            buttonLoadCheck={props.buttonLoadCheck?.[`${CARD_DRUG_CONT_ID}_REQUEST`]}
            // config
            color="green"
            name="REQUEST"
            size="small"
            style={{
              display:
                props.DrugSelectSequence?.id ||
                !props.drugPermission?.action_TPD_DrugContinuePlan_REQUEST
                  ? "none"
                  : "",
            }}
            title="REQUEST"
          />
        }
        openCalCulator={openCalCulator}
        pediatricUI={
          openCalCulator === true ? (
            <ModPediatricDose
              open={openCalCulator}
              onEvent={props.onEvent}
              setProp={props.setProp}
              drugDetail={props.selectedDrug?.original}
              pediatricData={props.pediatricData}
              // callback
              onClose={() => setOpenCalculator(false)}
              languageUX={props.languageUX}
            />
          ) : (
            <></>
          )
        }
        calculatorIcon={
          <CalculatorIcon
            enabledCalculatorButton={enableCalculatorButton}
            openCalCulator={openCalCulator}
            setOpenCalculator={setOpenCalculator}
          />
        }
        // calculatorIcon={
        //   !config.HIDE_DOSE_CALCULATOR && (
        //     <div
        //       fluid={true}
        //       onClick={() => {
        //         if (enableCalculatorButton) {
        //           setOpenCalculator(!openCalCulator);
        //         }
        //       }}
        //       style={{ whiteSpace: "nowrap" }}
        //     >
        //       <svg
        //         width="49"
        //         height="44"
        //         viewBox="0 0 49 44"
        //         fill="none"
        //         xmlns="http://www.w3.org/2000/svg"
        //       >
        //         <path
        //           d="M7.94727 38.6416H9.40723C9.37793 39.1201 9.24609 39.5449 9.01172 39.916C8.7806 40.2871 8.45671 40.5768 8.04004 40.7852C7.62663 40.9935 7.12858 41.0977 6.5459 41.0977C6.09017 41.0977 5.68164 41.0195 5.32031 40.8633C4.95898 40.7038 4.64974 40.4759 4.39258 40.1797C4.13867 39.8835 3.94499 39.5254 3.81152 39.1055C3.67806 38.6855 3.61133 38.2152 3.61133 37.6943V37.2012C3.61133 36.6803 3.67969 36.21 3.81641 35.79C3.95638 35.3669 4.15495 35.0072 4.41211 34.7109C4.67253 34.4147 4.9834 34.1868 5.34473 34.0273C5.70605 33.8678 6.1097 33.7881 6.55566 33.7881C7.14811 33.7881 7.64779 33.8955 8.05469 34.1104C8.46484 34.3252 8.78223 34.6214 9.00684 34.999C9.2347 35.3766 9.37142 35.8063 9.41699 36.2881H7.95215C7.93587 36.0016 7.87891 35.7591 7.78125 35.5605C7.68359 35.3587 7.53548 35.2074 7.33691 35.1064C7.1416 35.0023 6.88118 34.9502 6.55566 34.9502C6.31152 34.9502 6.09831 34.9958 5.91602 35.0869C5.73372 35.1781 5.58073 35.3164 5.45703 35.502C5.33333 35.6875 5.24056 35.9219 5.17871 36.2051C5.12012 36.485 5.09082 36.8138 5.09082 37.1914V37.6943C5.09082 38.0622 5.11849 38.3861 5.17383 38.666C5.22917 38.9427 5.3138 39.1771 5.42773 39.3691C5.54492 39.5579 5.69466 39.7012 5.87695 39.7988C6.0625 39.8932 6.28548 39.9404 6.5459 39.9404C6.85189 39.9404 7.10417 39.8916 7.30273 39.7939C7.5013 39.6963 7.65267 39.5514 7.75684 39.3594C7.86426 39.1673 7.92773 38.9281 7.94727 38.6416ZM13.1328 39.8086V37.4551C13.1328 37.2858 13.1051 37.141 13.0498 37.0205C12.9945 36.8968 12.9082 36.8008 12.791 36.7324C12.6771 36.6641 12.529 36.6299 12.3467 36.6299C12.1904 36.6299 12.0553 36.6576 11.9414 36.7129C11.8275 36.765 11.7396 36.8415 11.6777 36.9424C11.6159 37.04 11.585 37.1556 11.585 37.2891H10.1787C10.1787 37.0645 10.2308 36.8512 10.335 36.6494C10.4391 36.4476 10.5905 36.2702 10.7891 36.1172C10.9876 35.9609 11.2236 35.8389 11.4971 35.751C11.7738 35.6631 12.083 35.6191 12.4248 35.6191C12.835 35.6191 13.1995 35.6875 13.5186 35.8242C13.8376 35.9609 14.0882 36.166 14.2705 36.4395C14.4561 36.7129 14.5488 37.0547 14.5488 37.4648V39.7256C14.5488 40.0153 14.5667 40.2529 14.6025 40.4385C14.6383 40.6208 14.6904 40.7803 14.7588 40.917V41H13.3379C13.2695 40.8568 13.2174 40.6777 13.1816 40.4629C13.1491 40.2448 13.1328 40.0267 13.1328 39.8086ZM13.3184 37.7822L13.3281 38.5781H12.542C12.3564 38.5781 12.1953 38.5993 12.0586 38.6416C11.9219 38.6839 11.8096 38.7441 11.7217 38.8223C11.6338 38.8971 11.5687 38.985 11.5264 39.0859C11.4873 39.1868 11.4678 39.2975 11.4678 39.418C11.4678 39.5384 11.4954 39.6475 11.5508 39.7451C11.6061 39.8395 11.6859 39.9144 11.79 39.9697C11.8942 40.0218 12.0163 40.0479 12.1562 40.0479C12.3678 40.0479 12.5518 40.0055 12.708 39.9209C12.8643 39.8363 12.9847 39.7321 13.0693 39.6084C13.1572 39.4847 13.2028 39.3675 13.2061 39.2568L13.5771 39.8525C13.5251 39.986 13.4535 40.1243 13.3623 40.2676C13.2744 40.4108 13.1621 40.5459 13.0254 40.6729C12.8887 40.7965 12.7243 40.8991 12.5322 40.9805C12.3402 41.0586 12.1123 41.0977 11.8486 41.0977C11.5133 41.0977 11.209 41.0309 10.9355 40.8975C10.6654 40.7607 10.4505 40.5736 10.291 40.3359C10.1348 40.0951 10.0566 39.8216 10.0566 39.5156C10.0566 39.2389 10.1087 38.9932 10.2129 38.7783C10.3171 38.5635 10.4701 38.3828 10.6719 38.2363C10.877 38.0866 11.1325 37.9743 11.4385 37.8994C11.7445 37.8213 12.0993 37.7822 12.5029 37.7822H13.3184ZM17.1172 33.5V41H15.7061V33.5H17.1172ZM18.3477 40.3213C18.3477 40.113 18.4193 39.9388 18.5625 39.7988C18.709 39.6589 18.9027 39.5889 19.1436 39.5889C19.3844 39.5889 19.5765 39.6589 19.7197 39.7988C19.8662 39.9388 19.9395 40.113 19.9395 40.3213C19.9395 40.5296 19.8662 40.7038 19.7197 40.8438C19.5765 40.9837 19.3844 41.0537 19.1436 41.0537C18.9027 41.0537 18.709 40.9837 18.5625 40.8438C18.4193 40.7038 18.3477 40.5296 18.3477 40.3213ZM25.9404 41H24.3926L24.4023 39.8574H25.9404C26.3245 39.8574 26.6484 39.7712 26.9121 39.5986C27.1758 39.4229 27.3743 39.1673 27.5078 38.832C27.6445 38.4967 27.7129 38.0915 27.7129 37.6162V37.2695C27.7129 36.9049 27.6738 36.5843 27.5957 36.3076C27.5208 36.0309 27.4085 35.7982 27.2588 35.6094C27.109 35.4206 26.9251 35.279 26.707 35.1846C26.4889 35.0869 26.2383 35.0381 25.9551 35.0381H24.3633V33.8906H25.9551C26.4303 33.8906 26.8649 33.972 27.2588 34.1348C27.6559 34.2943 27.9993 34.5238 28.2891 34.8232C28.5788 35.1227 28.8018 35.4808 28.958 35.8975C29.1175 36.3109 29.1973 36.7715 29.1973 37.2793V37.6162C29.1973 38.1208 29.1175 38.5814 28.958 38.998C28.8018 39.4147 28.5788 39.7728 28.2891 40.0723C28.0026 40.3685 27.6592 40.598 27.2588 40.7607C26.8617 40.9202 26.4222 41 25.9404 41ZM25.2227 33.8906V41H23.7578V33.8906H25.2227ZM29.9492 38.4121V38.3096C29.9492 37.9222 30.0046 37.5658 30.1152 37.2402C30.2259 36.9115 30.387 36.6266 30.5986 36.3857C30.8102 36.1449 31.0706 35.9577 31.3799 35.8242C31.6891 35.6875 32.0439 35.6191 32.4443 35.6191C32.8447 35.6191 33.2012 35.6875 33.5137 35.8242C33.8262 35.9577 34.0882 36.1449 34.2998 36.3857C34.5146 36.6266 34.6774 36.9115 34.7881 37.2402C34.8988 37.5658 34.9541 37.9222 34.9541 38.3096V38.4121C34.9541 38.7962 34.8988 39.1527 34.7881 39.4814C34.6774 39.807 34.5146 40.0918 34.2998 40.3359C34.0882 40.5768 33.8278 40.764 33.5186 40.8975C33.2093 41.0309 32.8545 41.0977 32.4541 41.0977C32.0537 41.0977 31.6973 41.0309 31.3848 40.8975C31.0755 40.764 30.8135 40.5768 30.5986 40.3359C30.387 40.0918 30.2259 39.807 30.1152 39.4814C30.0046 39.1527 29.9492 38.7962 29.9492 38.4121ZM31.3555 38.3096V38.4121C31.3555 38.6335 31.375 38.8402 31.4141 39.0322C31.4531 39.2243 31.515 39.3936 31.5996 39.54C31.6875 39.6833 31.8014 39.7956 31.9414 39.877C32.0814 39.9583 32.2523 39.999 32.4541 39.999C32.6494 39.999 32.8171 39.9583 32.957 39.877C33.097 39.7956 33.2093 39.6833 33.2939 39.54C33.3786 39.3936 33.4404 39.2243 33.4795 39.0322C33.5218 38.8402 33.543 38.6335 33.543 38.4121V38.3096C33.543 38.0947 33.5218 37.8929 33.4795 37.7041C33.4404 37.512 33.377 37.3428 33.2891 37.1963C33.2044 37.0465 33.0921 36.9294 32.9521 36.8447C32.8122 36.7601 32.6429 36.7178 32.4443 36.7178C32.2458 36.7178 32.0765 36.7601 31.9365 36.8447C31.7998 36.9294 31.6875 37.0465 31.5996 37.1963C31.515 37.3428 31.4531 37.512 31.4141 37.7041C31.375 37.8929 31.3555 38.0947 31.3555 38.3096ZM38.6748 39.54C38.6748 39.4391 38.6455 39.348 38.5869 39.2666C38.5283 39.1852 38.4193 39.1104 38.2598 39.042C38.1035 38.9704 37.8773 38.9053 37.5811 38.8467C37.3141 38.7881 37.0651 38.7148 36.834 38.627C36.6061 38.5358 36.4076 38.4268 36.2383 38.2998C36.0723 38.1729 35.9421 38.0231 35.8477 37.8506C35.7533 37.6748 35.7061 37.4746 35.7061 37.25C35.7061 37.0286 35.7533 36.8203 35.8477 36.625C35.9453 36.4297 36.0837 36.2572 36.2627 36.1074C36.445 35.9544 36.6663 35.8356 36.9268 35.751C37.1904 35.6631 37.4867 35.6191 37.8154 35.6191C38.2744 35.6191 38.6683 35.6924 38.9971 35.8389C39.3291 35.9854 39.583 36.1872 39.7588 36.4443C39.9378 36.6982 40.0273 36.988 40.0273 37.3135H38.6211C38.6211 37.1768 38.5918 37.0547 38.5332 36.9473C38.4779 36.8366 38.39 36.7503 38.2695 36.6885C38.1523 36.6234 37.9993 36.5908 37.8105 36.5908C37.6543 36.5908 37.5192 36.6185 37.4053 36.6738C37.2913 36.7259 37.2035 36.7975 37.1416 36.8887C37.083 36.9766 37.0537 37.0742 37.0537 37.1816C37.0537 37.263 37.07 37.3363 37.1025 37.4014C37.1383 37.4632 37.1953 37.5202 37.2734 37.5723C37.3516 37.6243 37.4525 37.6732 37.5762 37.7188C37.7031 37.7611 37.8594 37.8001 38.0449 37.8359C38.4258 37.9141 38.766 38.0166 39.0654 38.1436C39.3649 38.2673 39.6025 38.4365 39.7783 38.6514C39.9541 38.863 40.042 39.1413 40.042 39.4863C40.042 39.7207 39.9899 39.9355 39.8857 40.1309C39.7816 40.3262 39.6318 40.4971 39.4365 40.6436C39.2412 40.7868 39.0068 40.8991 38.7334 40.9805C38.4632 41.0586 38.1589 41.0977 37.8203 41.0977C37.3288 41.0977 36.9121 41.0098 36.5703 40.834C36.2318 40.6582 35.9746 40.4352 35.7988 40.165C35.6263 39.8916 35.54 39.6117 35.54 39.3252H36.873C36.8796 39.5173 36.9284 39.6719 37.0195 39.7891C37.1139 39.9062 37.2327 39.9909 37.376 40.043C37.5225 40.0951 37.6803 40.1211 37.8496 40.1211C38.0319 40.1211 38.1833 40.0967 38.3037 40.0479C38.4242 39.9958 38.5153 39.9274 38.5771 39.8428C38.6423 39.7549 38.6748 39.654 38.6748 39.54ZM43.3867 41.0977C42.9766 41.0977 42.6087 41.0326 42.2832 40.9023C41.9577 40.7689 41.681 40.585 41.4531 40.3506C41.2285 40.1162 41.056 39.8444 40.9355 39.5352C40.8151 39.2227 40.7549 38.8906 40.7549 38.5391V38.3438C40.7549 37.9434 40.8118 37.5771 40.9258 37.2451C41.0397 36.9131 41.2025 36.625 41.4141 36.3809C41.6289 36.1367 41.8893 35.9495 42.1953 35.8193C42.5013 35.6859 42.8464 35.6191 43.2305 35.6191C43.6048 35.6191 43.9368 35.681 44.2266 35.8047C44.5163 35.9284 44.7588 36.1042 44.9541 36.332C45.1527 36.5599 45.3024 36.8333 45.4033 37.1523C45.5042 37.4681 45.5547 37.8197 45.5547 38.207V38.793H41.3555V37.8555H44.1729V37.748C44.1729 37.5527 44.137 37.3786 44.0654 37.2256C43.9971 37.0693 43.8929 36.9456 43.7529 36.8545C43.613 36.7633 43.4339 36.7178 43.2158 36.7178C43.0303 36.7178 42.8708 36.7585 42.7373 36.8398C42.6038 36.9212 42.4948 37.0352 42.4102 37.1816C42.3288 37.3281 42.2669 37.5007 42.2246 37.6992C42.1855 37.8945 42.166 38.1094 42.166 38.3438V38.5391C42.166 38.7507 42.1953 38.946 42.2539 39.125C42.3158 39.304 42.402 39.4587 42.5127 39.5889C42.6266 39.7191 42.7633 39.82 42.9229 39.8916C43.0856 39.9632 43.2695 39.999 43.4746 39.999C43.7285 39.999 43.9645 39.9502 44.1826 39.8525C44.404 39.7516 44.5944 39.6003 44.7539 39.3984L45.4375 40.1406C45.3268 40.3001 45.1755 40.4531 44.9834 40.5996C44.7946 40.7461 44.5667 40.8665 44.2998 40.9609C44.0329 41.0521 43.7285 41.0977 43.3867 41.0977Z"
        //           fill={enableCalculatorButton ? "#0072BC" : "#dddddd"}
        //         />
        //         <g clip-path="url(#clip0_848_9)">
        //           <path
        //             d="M12.75 30.322H25.8125C25.125 29.5166 24.375 29.0001 24.375 27.072C24.375 25.144 31 19.0001 32 20.0001V5.57202C32 4.84268 31.7103 4.1432 31.1945 3.62748C30.6788 3.11175 29.9793 2.82202 29.25 2.82202H12.75C12.0207 2.82202 11.3212 3.11175 10.8055 3.62748C10.2897 4.1432 10 4.84268 10 5.57202V27.572C10 28.3014 10.2897 29.0008 10.8055 29.5166C11.3212 30.0323 12.0207 30.322 12.75 30.322ZM16.875 26.197H14.125V23.447H16.875V26.197ZM16.875 20.697H14.125V17.947H16.875V20.697ZM16.875 15.197H14.125V12.447H16.875V15.197ZM22.375 26.197H19.625V23.447H22.375V26.197ZM22.375 20.697H19.625V17.947H22.375V20.697ZM22.375 15.197H19.625V12.447H22.375V15.197ZM27.875 22.0337L25.125 25.0001V17.947H27.875V22.0337ZM27.875 15.197H25.125V12.447H27.875V15.197ZM12.75 5.57202H29.25V9.69702H12.75V5.57202Z"
        //             fill={enableCalculatorButton ? "#0072BC" : "#dddddd"}
        //           />
        //           <path
        //             d="M33.4501 22.0417C32.8667 21.4584 32.1084 21.1667 31.4084 21.1667C30.7084 21.1667 29.8917 21.4584 29.3667 22.0417L25.9834 25.3084C24.8167 26.4751 24.8167 28.2834 25.9834 29.4501C27.1501 30.6167 28.9584 30.6167 30.1251 29.4501L33.4501 26.1251C34.5584 25.0167 34.5584 23.1501 33.4501 22.0417ZM32.6334 25.3084L31.0001 26.9417L28.9001 24.9001L26.3334 27.4667C26.3334 27.0001 26.4501 26.4751 26.8584 26.1251L30.1834 22.8001C30.4751 22.5084 30.9417 22.3334 31.3501 22.3334C31.7584 22.3334 32.2251 22.5084 32.5751 22.8001C33.2751 23.5584 33.2751 24.6084 32.6334 25.3084ZM35.4334 24.1417C35.4334 24.6084 35.3167 25.0167 35.2001 25.4834C35.7834 26.1834 35.7834 27.2334 35.1417 27.8751L33.5084 29.5084L32.6334 28.6334L31.0001 30.2667C30.2417 31.0251 29.1917 31.4334 28.2001 31.4334C28.3167 31.6084 28.4334 31.7834 28.6084 31.9584C29.7751 33.1251 31.5834 33.1251 32.7501 31.9584L36.0751 28.6334C37.2417 27.4667 37.2417 25.6584 36.0751 24.4917C35.7834 24.3751 35.6084 24.2584 35.4334 24.1417Z"
        //             fill={enableCalculatorButton ? "#0072BC" : "#dddddd"}
        //           />
        //         </g>
        //         <defs>
        //           <clipPath id="clip0_848_9">
        //             <rect width="33" height="33" fill="white" transform="translate(8)" />
        //           </clipPath>
        //         </defs>
        //       </svg>
        //     </div>
        //   )
        // }
        languageUX={props.languageUX}
      />

      {props.errorMessage?.[CARD_DUPLICATE_REASON] && (
        <CardDuplicateDrugOrders
          // function
          onClose={() =>
            props.setProp("errorMessage", {
              ...props.errorMessage,
              [CARD_DUPLICATE_REASON]: null,
            })
          }
          onApprove={handleConfirm}
          // options
          duplicateReasonsOptions={props.duplicateReasonsOptions}
          // data
          duplicateList={[props.errorMessage?.[CARD_DUPLICATE_REASON]]}
          languageUX={props.languageUX}
        />
      )}

      {props.errorMessage?.[CARD_DUPLICATE_CLASSIFICATION_REASON] && (
        <CardDuplicateDrugClassificationOrders
          // function
          onClose={() =>
            props.setProp("errorMessage", {
              ...props.errorMessage,
              [CARD_DUPLICATE_CLASSIFICATION_REASON]: null,
            })
          }
          onApprove={handleConfirmDrugGroupDuplicateWithReason}
          // options
          duplicateReasonsOptions={props.duplicateReasonsOptions}
          // data
          duplicateList={props.errorMessage?.[CARD_DUPLICATE_CLASSIFICATION_REASON]}
          languageUX={props.languageUX}
        />
      )}

      {props.DrugSelectSequence?.claim_payload?.have_question && (
        <CardDrugClaimQA
          // function
          onEvent={props.onEvent}
          onSave={handleSaveDrugClaimQA}
          // selected
          selectedEncounter={props.selectedEncounter}
          selectedEmr={props.selectedEmr}
          selectedProgressCycle={props.selectedProgressCycle}
          // data
          estimate={{
            ...props.DrugSelectSequence?.claim_payload,
            drug: props.DrugSelectSequence?.claim_payload?.selectedProduct,
          }}
          orderType="CONTINUE_PLAN"
          notSetAnswer={true}
          hideClose={!props.DrugSelectSequence?.claim_payload?.forceHaveQuestion}
          onClose={() => {
            if (props.DrugSelectSequence?.claim_payload?.forceHaveQuestion) {
              let payload = {
                ...props.DrugSelectSequence.claim_payload,
                forceHaveQuestion: false,
                have_question: false,
              };
              props.setProp("DrugSelectSequence.claim_payload", payload);
            }
          }}
          languageUX={props.languageUX}
        />
      )}

      {/* ADR */}
      <ModCheckADR
        DrugSelectSequence={props.DrugSelectSequence}
        onEvent={props.onEvent}
        setProp={props.setProp}
        errorMessage={props.errorMessage}
        card={CARD_DRUG_CONT_ID}
        languageUX={props.languageUX}
      />

      {/* DI */}
      <Modal size="tiny" open={!!props.DrugSelectSequence?.diFeedback}>
        <ModCheckDI
          diDetail={(props.DrugSelectSequence?.diItems || []).map((item: any, index: number) => (
            <div key={index} style={{ padding: "5px" }}>
              <div>{item.description}</div>
              {item.members_name.map((member_name: string, member_index: number) => (
                <div key={member_index}>{`${member_index}. ${member_name}`}</div>
              ))}
            </div>
          ))}
          needNote={!props.DrugSelectSequence?.diLock}
          acknowledge={() => {
            props.onEvent({
              message: "RunSequence",
              params: { sequence: "DrugSelect", feedback: "acknowledge" },
            });
          }}
          confirmOrder={() => {
            props.onEvent({
              message: "RunSequence",
              params: { sequence: "DrugSelect", feedback: "confirm" },
            });
          }}
          cancelOrder={() => {
            props.onEvent({
              message: "RunSequence",
              params: { sequence: "DrugSelect", feedback: "cancel" },
            });
          }}
          changeNote={(e: any) => {
            props.setProp("DrugSelectSequence.confirmDINote", e.target.value);
          }}
          languageUX={props.languageUX}
        />
      </Modal>

      {/* ModNote */}
      <Modal
        closeIcon
        open={props.modNoteData?.open}
        closeOnDimmerClick={true}
        style={{ width: "auto" }}
        onClose={handleCloseModNote}
      >
        <Modal.Content>
          <ErrorMessage error={props.modNoteData?.error} />

          <Grid>
            {props.modNoteData?.error?.["note"] && (
              <Form style={{ width: "100%" }}>
                <Grid.Column width={16}>ข้อความ</Grid.Column>
                <Grid.Column width={16}>
                  <TextArea
                    style={{ width: "100%" }}
                    name="note"
                    onChange={handleChangeModNoteData}
                  />
                </Grid.Column>
              </Form>
            )}

            {props.modNoteData?.error?.["doctor"] && (
              <>
                <Grid.Column width={16}>แพทย์</Grid.Column>
              </>
            )}

            {props.modNoteData?.error?.["first_quantity"] && (
              <>
                <Grid.Column width={16}>
                  จำนวนที่จะจ่ายครั้งแรกในวันนี้ (ใส่ 0 หากไม่จ่าย)
                </Grid.Column>

                <Grid.Column width={14}>
                  <Input
                    fluid
                    type="number"
                    name="first_quantity"
                    value={props.modNoteData?.first_quantity || ""}
                    onChange={handleChangeModNoteData}
                  />
                </Grid.Column>
                <Grid.Column width={2} style={{ paddingLeft: 0, margin: "auto" }}>
                  <Label size="large">{props.modNoteData?.stockUnitName}</Label>
                </Grid.Column>
              </>
            )}

            <Grid.Column style={{ flex: 1 }}></Grid.Column>
            <Grid.Column style={{ width: "fit-content" }}>
              <Button
                fluid
                color="green"
                size="small"
                style={{ minWidth: "max-content" }}
                onClick={() => {
                  if (
                    props.modNoteData?.error?.non_field_errors?.[0]?.includes("ยังไม่ถูกรับทราบโดย")
                  ) {
                    /// GoToMedreconcile
                    handleSaveModNote(true);
                  } else {
                    handleSaveModNote();
                  }
                }}
              >
                {props.modNoteData?.error?.non_field_errors?.[0]?.includes("ยังไม่ถูกรับทราบโดย")
                  ? "รับทราบ"
                  : "SAVE"}
              </Button>
            </Grid.Column>
          </Grid>
        </Modal.Content>
      </Modal>

      {/* Planning */}
      <Modal
        // closeIcon
        open={props.modPlanningConfig?.open}
        closeOnDimmerClick={true}
        onClose={handleCloseModPlanning}
      >
        <ModPlanning
          // function
          onEvent={props.onEvent}
          setProp={props.setProp}
          // CommonInterface
          buttonLoadCheck={props.buttonLoadCheck}
          // selected data
          selectedPatient={props.selectedPatient}
          selectedDrug={props.selectedDrug}
          // planning
          modPlanningConfig={props.modPlanningConfig}
          planningData={props.planningData}
          isDoctor={props.isDoctor}
          languageUX={props.languageUX}
        />
      </Modal>

      {/* SpecialDirection */}
      <Modal
        closeIcon
        open={props.modSpecialDirectionConfig?.open}
        closeOnDimmerClick={true}
        onClose={handleCloseModSpecialDirection}
      >
        <ModSpecialDirection
          // function
          onEvent={props.onEvent}
          // seq
          DrugSelectSequence={props.DrugSelectSequence}
          // data
          hideDuration={true}
          hideWeekday={true}
          hideAdminTime={false}
          hideIntraveneous={true}
          languageUX={props.languageUX}
        />
      </Modal>

      {/* SolventSelection */}
      {/* <Modal
        closeIcon
        open={props.modSolventSelectionConfig?.openModal}
        closeOnDimmerClick={true}
        onClose={handleCloseModSolventSelection}
      >
        <ModSolventSelection
          // function
          onEvent={props.onEvent}
          setProp={props.setProp}
          // permission
          drugPermission={props.drugPermission}
          // CommonInterface
          errorMessage={props.errorMessage}
          successMessage={props.successMessage}
          // seq
          DrugSelectSequence={props.DrugSelectSequence}
          // Master
          drugUnits={props.DrugSelectSequence?.drugUnits || []}
          // selected data
          selectedDrug={props.selectedDrug}
          // data
          drugOrderType={DRUG_ORDER_TYPE}
          modSolventSelectionConfig={props.modSolventSelectionConfig}
        />
      </Modal> */}

      {/* DoctorCertificateCheck */}
      <Modal open={props.modDoctorCertificate.open} size="small">
        <ModCheckDoctorCertificateUX
          hideInput={BYPASS_DOCTOR_CERT_KEYING} // Feature 68144
          narcoticTypeDetail={htmlParse(props.modDoctorCertificate?.narcoticDrugType || "")}
          doctorCertificate={props.modDoctorCertificate?.doctorCertificate}
          onInputChange={(_e: any, v: any) => {
            props.setProp("modDoctorCertificate.doctorCertificate", v.value);
          }}
          onApprove={() => {
            props.onEvent({
              message: "HandleCheckDoctorCertificate",
              params: {
                skipChecking: BYPASS_DOCTOR_CERT_KEYING,
              },
            });
          }}
          onCancel={() => {
            props.setProp("modDoctorCertificate.open", false);

            props.setProp(
              `buttonLoadCheck.${props.modDoctorCertificate.card}_${props.modDoctorCertificate.action}`,
              ""
            );
          }}
          languageUX={props.languageUX}
        />
      </Modal>

      {/* DoctorCertificateCheck error*/}
      <Modal
        open={props.modDoctorCertificate.openModConfirm}
        style={{ height: "auto", width: "300px" }}
      >
        <ModCertificateErrorUX
          onConfirm={() => {
            props.setProp("modDoctorCertificate.openModConfirm", false);
          }}
        />
      </Modal>

      <ModDrugEditNote
        setProp={props.setProp}
        open={!!modEditNote}
        type={modEditNote?.type}
        // callback
        onClose={handleCloseModEditNote}
        onSave={handleSaveEditNote}
        languageUX={props.languageUX}
      />

      {/* drug-lab interaction */}
      <Modal open={props.modDrugLabInteraction?.open} closeOnDimmerClick={false}>
        <ModDrugLabInteraction
          // main function
          runSequence={props.runSequence}
          setProp={props.setProp}
          onEvent={props.onEvent}
          // data
          modDrugLabInteraction={props.modDrugLabInteraction}
          isEditable={true}
          languageUX={props.languageUX}
          masterOptions={props.masterOptions}
        />
      </Modal>

      {/* drug-disease */}
      <Modal open={props.modDrugDisease?.open} closeOnDimmerClick={false}>
        <ModDrugDisease
          // main function
          runSequence={props.runSequence}
          setProp={props.setProp}
          onEvent={props.onEvent}
          // data
          modDrugDisease={props.modDrugDisease}
          isEditable={true}
          languageUX={props.languageUX}
          masterOptions={props.masterOptions}
        />
      </Modal>

      {/* drug-interaction */}
      <Modal open={props.modDrugInteraction?.open} closeOnDimmerClick={false}>
        <ModDrugInteraction
          onEvent={props.onEvent}
          setProp={props.setProp}
          // main function
          runSequence={props.runSequence}
          isEditable={true}
          languageUX={props.languageUX}
          // data
          modDrugInteraction={props.modDrugInteraction}
          masterOptions={props.masterOptions}
        />
      </Modal>

      {/* Action Log */}
      <Modal
        closeIcon
        open={props.DrugSelectSequence?.actionLogs?.open}
        closeOnDimmerClick={true}
        onClose={() => {
          props.setProp("DrugSelectSequence.actionLogs.open", false);
        }}
      >
        <DrugActionLog
          data={props.DrugSelectSequence?.actionLogs?.data?.items || []}
          languageUX={props.languageUX}
        />
      </Modal>

      {/* MedReconcile Check*/}
      <ModMedReconcileAlert
        onEvent={props.onEvent}
        setProp={props.setProp}
        django={props.django}
        medReconcileCheck={props.medReconcileCheck}
        medReconcileIndex={props.medReconcileIndex}
        open={props.medReconcileCheck?.open_card_med_reconciliation}
        languageUX={props.languageUX}
      />

      <ModDrugFact
        open={openModFactSheet}
        drugDetail={props.DrugSelectSequence}
        // callback
        onClose={handleCloseFactSheet}
        languageUX={props.languageUX}
      />

      <ModDescriptionUD
        open={!!modDrugDesc.open}
        description={modDrugDesc.desc}
        // config
        editable={true}
        // callback
        onApprove={handleConfirmDesc}
        onClose={handleCloseModDesc}
        languageUX={props.languageUX}
      />

      <ModConfirm
        size="tiny"
        open={modAgeWarn !== ""}
        openModal={modAgeWarn !== ""}
        titleColor={"red"}
        titleName={"แจ้งเตือนสั่งยานอกช่วงอายุที่กำหนด"}
        disabledApproveButton={!props.DrugSelectSequence?.note_limited_age}
        denyButtonColor="red"
        denyButtonText="ยกเลิก"
        approveButtonColor="green"
        approveButtonText="ยืนยัน"
        onApprove={() => {
          let tmp = `${limitedAge}`;
          props.setProp("DrugSelectSequence.limited_age", tmp);

          if (props.selectedDrug?.original?.locked_if_age_is_outside_specified_range) {
            props.onEvent({ message: "ClearDrugOrderForm", params: { hard: true } });
            // setModSaveWeightWarn(false);
            props.setProp("pediatricData", null);
            setModAgeWarn("");
            setLimitedAge("");
          } else {
            if (props.DrugSelectSequence?.note_limited_age) {
              setModAgeWarn("");
              setLimitedAge("");
            }
          }
        }}
        onDeny={() => {
          setModAgeWarn("");
          props.onEvent({ message: "ClearDrugOrderForm", params: { hard: true } });
          // setModSaveWeightWarn(false);
          props.setProp("pediatricData", null);
        }}
        onCloseWithDimmerClick={() => {
          setModAgeWarn("");
          props.onEvent({ message: "ClearDrugOrderForm", params: { hard: true } });
          // setModSaveWeightWarn(false);
          props.setProp("pediatricData", null);
        }}
        onClose={() => {
          setModAgeWarn("");
          props.onEvent({ message: "ClearDrugOrderForm", params: { hard: true } });
          // setModSaveWeightWarn(false);
          props.setProp("pediatricData", null);
        }}
        content={
          <>
            <div>
              {props.selectedDrug?.original?.locked_if_age_is_outside_specified_range ? (
                <div
                  style={{
                    textAlign: "center",
                    fontSize: "1.2rem",
                    fontWeight: "bold",
                    paddingTop: "10px",
                  }}
                >
                  {intl.formatMessage({ id: "ไม่อนุญาตให้สั่งยารายการนี้" })}
                </div>
              ) : (
                <></>
              )}
              {modAgeWarn ? (
                <div
                  style={{
                    textAlign: "center",
                    fontSize: "1.2rem",
                    fontWeight: "bold",
                    padding: "10px",
                  }}
                >
                  {modAgeWarn}
                </div>
              ) : (
                <></>
              )}
              <div>
                {" "}
                ช่วงอายุต่ำสุดที่แนะนำสำหรับใช้ยารายการนี้ คือ{" "}
                {props.selectedDrug?.original?.minimum_age_year} ปี{" "}
                {props.selectedDrug?.original?.minimum_age_month} เดือน{" "}
              </div>
              <div>
                {" "}
                ช่วงอายุสูงสุดที่แนะนำสำหรับใช้ยารายการนี้ คือ{" "}
                {props.selectedDrug?.original?.maximum_age_year} ปี{" "}
                {props.selectedDrug?.original?.maximum_age_month} เดือน{" "}
              </div>
            </div>
            {props.selectedDrug?.original?.locked_if_age_is_outside_specified_range ? (
              <></>
            ) : (
              <div style={{ paddingTop: "5px" }}>
                <Form>
                  <Form.Field label="กรุณาใส่เหตุผลสำหรับยืนยันการสั่งยา"></Form.Field>
                  <Form.Field>
                    <Dropdown
                      allowAdditions={true}
                      onAddItem={(e: any, v: any) => {
                        setReasonOptions([
                          { key: v.value, text: v.value, value: v.value },
                          ...reasonOptions,
                        ]);
                      }}
                      search={true}
                      fluid={true}
                      clearable={true}
                      selection={true}
                      options={reasonOptions || []}
                      value={props.DrugSelectSequence?.note_limited_age || ""}
                      onChange={(e: any, data: any) => {
                        props.setProp("DrugSelectSequence.limited_age", limitedAge);
                        props.setProp("DrugSelectSequence.note_limited_age", data.value);
                      }}
                      style={{ width: "100%" }}
                    />
                  </Form.Field>
                </Form>
              </div>
            )}
          </>
        }
      />
    </div>
  );
};

export default React.memo(CardDrugContinuePlan);
